import {TrackJS} from 'trackjs';

const {start} = window;
const {trackjs_token: token} = start.settings;
const trackJSConfig = {
  token,
  application: 'checkout',
  sessionId: start.trackingId,
};

const {customer} = start;
if (customer) {
  trackJSConfig.userId = String(customer.customerId);
  TrackJS.addMetadata('customerLocation', String(customer.location));
}

if (start.orderNumber) {
  TrackJS.addMetadata('orderNumber', String(start.orderNumber));
  TrackJS.addMetadata('guest', String(start.guestCheckout));
}

const siteData = start.siteDataV2;
if (siteData) {
  TrackJS.addMetadata('siteName', String(siteData.siteName));
}

TrackJS.install(trackJSConfig);

const tracking = {
  exception: (err) => {
    TrackJS.track(err);
  },
  track: (msg) => {
    TrackJS.track(msg);
  },
  warn: (msg) => {
    TrackJS.console.warn(msg);
  },
  error: (msg) => {
    TrackJS.console.error(msg);
  },
  log: message => TrackJS.console.log(message),
};

export default tracking;
